import { useCategories } from '../hooks/useCategories';
import './FilterPanel.css';

/**
 * FilterPanel Component
 * Category filter — dynamically loaded from the database
 */
const FilterPanel = ({ selectedCategory, onCategoryChange }) => {
  const { list } = useCategories();

  const categories = [
    { code: null, name: 'All Categories', color: 'black' },
    ...list,
  ];

  return (
    <div className="categories">
      {categories.map(cat => (
        <div
          key={cat.code || 'all'}
          className={`cat-item ${selectedCategory === cat.code ? 'active' : ''}`}
          onClick={() => onCategoryChange(cat.code)}
        >
          <div className="box" style={{ background: cat.color }}></div>
          {cat.name}
        </div>
      ))}
    </div>
  );
};

export default FilterPanel;
